import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ee95c42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"8px"} }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "search-btn-radio"
}
const _hoisted_4 = {
  key: 3,
  class: "search-btn-radio"
}
const _hoisted_5 = { class: "pagination" }
const _hoisted_6 = { class: "info-title" }
const _hoisted_7 = { class: "info-title" }
const _hoisted_8 = { class: "info-title" }
const _hoisted_9 = { class: "info-title" }
const _hoisted_10 = { class: "info-title" }
const _hoisted_11 = { class: "info-title" }
const _hoisted_12 = { class: "info-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Product", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Variant", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Warehouse", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Type", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Quantity", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Transaction date", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Notes", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Product", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Variant", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Warehouse", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Type", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Quantity", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Transaction date", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Notes", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LbrxLoaderSpinner = _resolveComponent("LbrxLoaderSpinner")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_search_outlined = _resolveComponent("search-outlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_LbrxLoaderSpinner, {
        "is-loaded": !_ctx.loading
      }, null, 8, ["is-loaded"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_breadcrumb, { style: {"margin":"16px 0"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_breadcrumb_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigatePage('/'))),
            class: "breadcrumb-icon"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Pos.Dashboard')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Pos.Inventory')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Pos.Transactions')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_table, {
        class: "table-container",
        columns: _ctx.columns,
        "data-source": _ctx.state.data,
        pagination: false
      }, {
        emptyText: _withCtx(() => [
          _createVNode(_component_a_empty, {
            description: _ctx.t('Pos.NoData'),
            image: _ctx.simpleImage
          }, null, 8, ["description", "image"])
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column.key=='actions')
            ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('Pos.View')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        class: "view-btn",
                        onClick: () => _ctx.showDisplayDrawer(record)
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_EyeOutlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (column.key=='item_type')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (record.product!==null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(record.product.name), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (record.ingredient!==null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(record.ingredient.name), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.key=='type')
            ? (_openBlock(), _createBlock(_component_a_tag, { key: 2 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t(`Pos.${record.type}`)), 1)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (column.key=='item')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                (record.product!==null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.t('Pos.Product')), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (record.ingredient!==null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.t('Pos.Ingredient')), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'transaction_date')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDisplayDate(record[column.key])), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        customFilterDropdown: _withCtx(({ setSelectedKeys, selectedKeys, confirm, clearFilters, column }) => [
          _createElementVNode("div", _hoisted_1, [
            (column.key === 'name')
              ? (_openBlock(), _createBlock(_component_a_input, {
                  key: 0,
                  ref: "searchInput",
                  placeholder: `${column.title}`,
                  value: selectedKeys[0],
                  style: {"width":"188px","margin-bottom":"8px","display":"block"},
                  onChange: e => setSelectedKeys(e.target.value ? [e.target.value] : []),
                  onPressEnter: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
                }, null, 8, ["placeholder", "value", "onChange", "onPressEnter"]))
              : _createCommentVNode("", true),
            (column.key === 'transaction_date')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_a_date_picker, {
                    value: _ctx.transaction_date,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.transaction_date) = $event)),
                    class: "date-input"
                  }, null, 8, ["value"])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'item')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_a_radio_group, {
                    value: _ctx.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value) = $event)),
                    onChange: _ctx.selectedType,
                    class: "search-radio-grp"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, {
                        value: "product",
                        class: "radio-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Pos.Product')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, {
                        value: "ingredient",
                        class: "radio-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Pos.Ingredient')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "onChange"])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'type')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_a_radio_group, {
                    value: _ctx.value,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value) = $event)),
                    onChange: _ctx.selectedInventoryType,
                    class: "search-radio-grp"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, {
                        value: "sale",
                        class: "radio-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Pos.sale')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, {
                        value: "transfered",
                        class: "radio-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Pos.transfered')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, {
                        value: "adjustment",
                        class: "radio-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Pos.adjustment')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, {
                        value: "received",
                        class: "radio-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Pos.received')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "onChange"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, {
              type: "primary",
              size: "small",
              style: {"width":"90px","margin-right":"5px"},
              onClick: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Pos.Search')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              size: "small",
              style: {"width":"90px"},
              onClick: ($event: any) => (_ctx.handleReset(clearFilters))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('Pos.Reset')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        customFilterIcon: _withCtx(({ filtered }) => [
          _createVNode(_component_search_outlined, {
            style: _normalizeStyle({ color: filtered ? '#108ee9' : undefined })
          }, null, 8, ["style"])
        ]),
        _: 1
      }, 8, ["columns", "data-source"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_pagination, {
          class: "paginationArrows",
          current: _ctx.currentPage,
          "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentPage) = $event)),
          pageSize: _ctx.perPage,
          "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.perPage) = $event)),
          total: _ctx.state.totalPages,
          "default-page-size": _ctx.perPage,
          showSizeChanger: false,
          onChange: _ctx.handlePageChange
        }, null, 8, ["current", "pageSize", "total", "default-page-size", "onChange"]),
        (_ctx.state.totalPages>10)
          ? (_openBlock(), _createBlock(_component_a_select, {
              key: 0,
              class: "select-input",
              value: _ctx.selectPagination,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectPagination) = $event)),
              onChange: _ctx.handleSelectPaginationChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: "10" }, {
                  default: _withCtx(() => [
                    _createTextVNode("10 / " + _toDisplayString(_ctx.t('Pos.page')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "20" }, {
                  default: _withCtx(() => [
                    _createTextVNode("20 / " + _toDisplayString(_ctx.t('Pos.page')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "50" }, {
                  default: _withCtx(() => [
                    _createTextVNode("50 / " + _toDisplayString(_ctx.t('Pos.page')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "100" }, {
                  default: _withCtx(() => [
                    _createTextVNode("100 / " + _toDisplayString(_ctx.t('Pos.page')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "onChange"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_a_drawer, {
        open: _ctx.openDisplay,
        "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.openDisplay) = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        placement: _ctx.locale === 'ar' ? 'left' : 'right',
        width: _ctx.modalWidth,
        onAfterOpenChange: _ctx.afterOpenChange
      }, {
        title: _withCtx(() => [
          _createElementVNode("p", {
            class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
          }, _toDisplayString(_ctx.t('Pos.InventoryTransactionInfo')), 3)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "formRef",
            model: _ctx.form,
            rules: _ctx.rules,
            layout: "vertical",
            class: _normalizeClass({ 'is-rtl': _ctx.textDirection==='rtl'})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('Pos.Item')) + " :", 1),
                        (_ctx.form.product!==null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.form.product.name), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.form.ingredient!==null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_ctx.form.ingredient.name), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('Pos.Variant(s)')) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.form.variant_id) + " ", 1),
                        (_ctx.form.variant_id===null)
                          ? (_openBlock(), _createBlock(_component_a_tag, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Pos.Emptyfield')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('Pos.Warehouse')) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.form.warehouse_id.name) + " ", 1),
                        (_ctx.form.warehouse_id===null)
                          ? (_openBlock(), _createBlock(_component_a_tag, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Pos.Emptyfield')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('Pos.Type')) + " :", 1),
                        _createVNode(_component_a_tag, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t(`Pos.${_ctx.form.type}`)), 1)
                          ]),
                          _: 1
                        }),
                        (_ctx.form.type===null)
                          ? (_openBlock(), _createBlock(_component_a_tag, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Pos.Emptyfield')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('Pos.Quantity')) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.form.quantity) + " ", 1),
                        (_ctx.form.quantity===null)
                          ? (_openBlock(), _createBlock(_component_a_tag, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Pos.Emptyfield')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t('Pos.TransactionDate')) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatStringDate(_ctx.form.transaction_date)) + " ", 1),
                        (_ctx.form.transaction_date===null)
                          ? (_openBlock(), _createBlock(_component_a_tag, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Pos.Emptyfield')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('Pos.Notes')) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.form.notes) + " ", 1),
                        (_ctx.form.notes===null)
                          ? (_openBlock(), _createBlock(_component_a_tag, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Pos.Emptyfield')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "class"])
        ]),
        _: 1
      }, 8, ["open", "placement", "width", "onAfterOpenChange"]),
      _createVNode(_component_a_drawer, {
        open: _ctx.open,
        "onUpdate:open": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.open) = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        placement: _ctx.locale === 'ar' ? 'left' : 'right',
        width: 720,
        onAfterOpenChange: _ctx.afterOpenChange
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateUser(_ctx.form.id)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Update")
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                danger: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "formRef",
            model: _ctx.form,
            rules: _ctx.rules,
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "product_id" }, {
                        label: _withCtx(() => [
                          _hoisted_13
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            placeholder: "Please choose the product",
                            value: _ctx.form.product_id,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.product_id) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.products, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.id,
                                  value: item.id,
                                  selected: item.id === _ctx.form.product_id 
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "selected"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "variant_id" }, {
                        label: _withCtx(() => [
                          _hoisted_14
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            placeholder: "Please choose variant",
                            value: _ctx.form.variant_id,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.variant_id) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.variants, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.id,
                                  value: item.id,
                                  selected: item.id === _ctx.form.variant_id 
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "selected"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "warehouse_id" }, {
                        label: _withCtx(() => [
                          _hoisted_15
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            placeholder: "Please choose variant",
                            value: _ctx.form.warehouse_id,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.warehouse_id) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.warehouses, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.id,
                                  value: item.id,
                                  selected: item.id === _ctx.form.warehouse_id 
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "selected"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "type" }, {
                        label: _withCtx(() => [
                          _hoisted_16
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _ctx.form.type,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.type) = $event)),
                            "show-search": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: "transfer" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Transfer")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "quantity" }, {
                        label: _withCtx(() => [
                          _hoisted_17
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.form.quantity,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.quantity) = $event)),
                            placeholder: "Quantity"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "transaction_date" }, {
                        label: _withCtx(() => [
                          _hoisted_18
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_date_picker, {
                            value: _ctx.form.transaction_date,
                            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.transaction_date) = $event)),
                            class: "date-picker"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "notes" }, {
                        label: _withCtx(() => [
                          _hoisted_19
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_textarea, {
                            value: _ctx.form.notes,
                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.notes) = $event)),
                            rows: 4,
                            placeholder: "Notes"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["open", "placement", "onAfterOpenChange"]),
      _createVNode(_component_a_drawer, {
        open: _ctx.openAdd,
        "onUpdate:open": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.openAdd) = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        title: "Add inventory transaction",
        placement: "right",
        width: 720,
        onAfterOpenChange: _ctx.afterOpenAddChange
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.add
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Add")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                danger: "",
                onClick: _ctx.resetFormAdd
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "addFormRef",
            model: _ctx.addForm,
            rules: _ctx.rules,
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "product_id" }, {
                        label: _withCtx(() => [
                          _hoisted_20
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            placeholder: "Please choose the product",
                            value: _ctx.addForm.product_id,
                            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.addForm.product_id) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.products, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.id,
                                  value: item.id,
                                  selected: item.id === _ctx.addForm.product_id 
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "selected"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "variant_id" }, {
                        label: _withCtx(() => [
                          _hoisted_21
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            placeholder: "Please choose variant",
                            value: _ctx.addForm.variant_id,
                            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.addForm.variant_id) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.variants, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.id,
                                  value: item.id,
                                  selected: item.id === _ctx.addForm.variant_id 
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "selected"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "warehouse_id" }, {
                        label: _withCtx(() => [
                          _hoisted_22
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            placeholder: "Please choose variant",
                            value: _ctx.addForm.warehouse_id,
                            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.addForm.warehouse_id) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.warehouses, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.id,
                                  value: item.id,
                                  selected: item.id === _ctx.addForm.warehouse_id 
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "selected"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "type" }, {
                        label: _withCtx(() => [
                          _hoisted_23
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _ctx.addForm.type,
                            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.addForm.type) = $event)),
                            "show-search": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: "transfer" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Transfer")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "quantity" }, {
                        label: _withCtx(() => [
                          _hoisted_24
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.addForm.quantity,
                            "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.addForm.quantity) = $event)),
                            placeholder: "Quantity"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "transaction_date" }, {
                        label: _withCtx(() => [
                          _hoisted_25
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_date_picker, {
                            value: _ctx.addForm.transaction_date,
                            "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.addForm.transaction_date) = $event)),
                            class: "date-picker"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "notes" }, {
                        label: _withCtx(() => [
                          _hoisted_26
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_textarea, {
                            value: _ctx.addForm.notes,
                            "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.addForm.notes) = $event)),
                            rows: 4,
                            placeholder: "Notes"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["open", "onAfterOpenChange"])
    ])
  ], 64))
}